import React, { useMemo } from 'react';

import { ISTOInvoiceMappedData } from './interfaces';
import { STOInvoicePrintTemplateComponent } from './STOInvoicePrintTemplate.component';

export const STOInvoicePrintTemplate: React.FC = () => {
  document.body.className = 'print-template';

  const data: ISTOInvoiceMappedData | null = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('sto-invoice') || 'null');
    } catch {
      return null;
    }
  }, []);

  if (!data) {
    return <div>Data is not loaded</div>;
  }
  return <STOInvoicePrintTemplateComponent data={data} />;
};
